import React from 'react';
import { FaInfoCircle, FaLink, FaTimes } from 'react-icons/fa';

const GIFT_SET_RULES = [
  {
    label: 'Owner edits content',
    detail: 'Only the master NFC can edit gift content and manage members.',
  },
  {
    label: 'Members open owner page',
    detail: 'Member NFCs are entry points and always show the owner gift.',
  },
  {
    label: 'System NFC only',
    detail: 'Only registered Lumirae NFCs can be paired for security.',
  },
];

const GiftSetSettingsHeader = ({ onClose, theme }) => (
  <div className="relative shrink-0 overflow-hidden rounded-[1.25rem] border p-4" style={{ borderColor: theme.cardBorder, backgroundColor: theme.cardBg }}>
    <div className="absolute right-3 top-3 h-24 w-24 rounded-full opacity-20 blur-2xl" style={{ backgroundColor: theme.accentSoft }} />
    <div className="relative flex items-start gap-4">
      <div
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[1.25rem]"
        style={{ backgroundColor: theme.accentSoft, color: theme.accent }}
      >
        <FaLink />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[9px] font-black uppercase tracking-[0.24em]" style={{ color: theme.accent }}>
          Gift Set Control
        </p>
        <h3 className="mt-1 text-xl font-black uppercase tracking-tight leading-none" style={{ color: theme.text }}>
          NFC Members
        </h3>
        <p className="mt-2 text-xs font-semibold leading-relaxed" style={{ color: theme.secondaryText || theme.text }}>
          Add candle jars, table cards, or favor tags by scanning. No UUID typing needed.
        </p>
      </div>
      <button type="button" onClick={onClose} className="lumirae-ds-icon-button h-9 w-9" aria-label="Close Gift Set settings">
        <FaTimes />
      </button>
    </div>

    <div
      className="relative mt-3 rounded-[1rem] border bg-white/45 p-3"
      style={{ borderColor: theme.cardBorder }}
      aria-label="Gift Set read-only security rules"
    >
      <div className="flex items-center gap-2 text-[8px] font-black uppercase tracking-[0.22em]" style={{ color: theme.accent }}>
        <FaInfoCircle />
        <span>Read-only security rules</span>
      </div>
      <div className="mt-2 grid gap-2">
        {GIFT_SET_RULES.map((rule) => (
          <div key={rule.label} className="rounded-[0.9rem] bg-white/55 px-3 py-2">
            <strong className="block text-[8px] font-black uppercase leading-snug tracking-widest" style={{ color: theme.text }}>
              {rule.label}
            </strong>
            <span className="mt-1 block text-[10px] font-medium leading-relaxed" style={{ color: theme.secondaryText }}>
              {rule.detail}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default GiftSetSettingsHeader;
